import React from 'react';
import About from './about';
import AboutMe from './about_me';
import Contact from './contact';
import Footer from './footer';
import Header from './header';
import Project from './project';
import Skills from './skills';
import './home.css';
 
const Home = () =>{
    
    return(
       
         <div>
       
        <Header />
        <About />
        <AboutMe />
        <Skills />
         <Project />
         <Contact />
         <Footer />
        </div>
        
      
    );
}


export default Home;